/**
 * Perfil ativo é de cliente final? ('Cliente' ou 'ClienteFinal' — o nome varia
 * por tenant). Regra de negócio: um pedido tem UMA categoria só (WS venda,
 * WD doação, WC certificação) — o catálogo é filtrado pelo tipo de pedido
 * selecionado e não é permitido misturar categorias no mesmo pedido. Se o
 * cliente buscar um produto de outra categoria, o sistema apenas informa que
 * a categoria é diferente e que é preciso fazer um novo pedido.
 */
/**
 * Lista canônica de perfis "de cliente" para gates de VISIBILIDADE de menu/telas
 * (dashboards, CRM, busca global, aniversariantes...). O nome do perfil varia
 * por tenant: 'Cliente' (macmillan), 'ClienteFinal', 'ClienteHanes' (Hanes),
 * 'PortalCliente'. Use SEMPRE esta constante — não duplique listas nas telas.
 */
export const PERFIS_CLIENTE = ['Cliente', 'ClienteFinal', 'ClienteHanes', 'PortalCliente'];

export function podeSelecionarFormaPagamento() {
  try {
    const perfil = JSON.parse(localStorage.getItem('perfilLogado') || '{}');
    const nome = String(perfil.perfil_acesso_nome || '').trim().toLowerCase();
    return [...PERFIS_CLIENTE.map(p => p.toLowerCase()), 'admindkp', 'administrador', 'comercial'].includes(nome);
  } catch {
    return false;
  }
}

export function isPerfilClienteAtivo() {
  try {
    const perfil = JSON.parse(localStorage.getItem('perfilLogado') || '{}');
    // Usa PERFIS_CLIENTE como fonte canônica — inclui ClienteHanes, PortalCliente etc.
    return PERFIS_CLIENTE.includes(perfil.perfil_acesso_nome);
  } catch {
    return false;
  }
}

/** Perfil ativo é Representante? Regra: representante NUNCA pode vender sem estoque. */
export function isPerfilRepresentanteAtivo() {
  try {
    const perfil = JSON.parse(localStorage.getItem('perfilLogado') || '{}');
    return String(perfil.perfil_acesso_nome || '').toLowerCase().includes('representante');
  } catch {
    return false;
  }
}

/** Perfil ativo é Supervisor? Usado no gate de ocultação de info comercial. */
export function isPerfilSupervisorAtivo() {
  try {
    const perfil = JSON.parse(localStorage.getItem('perfilLogado') || '{}');
    return String(perfil.perfil_acesso_nome || '').toLowerCase().includes('supervisor');
  } catch {
    return false;
  }
}

/** Perfil ativo é administrador (Administrador/AdminDKP)? Usado para gates de ações restritas. */
export function isPerfilAdminAtivo() {
  try {
    const perfil = JSON.parse(localStorage.getItem('perfilLogado') || '{}');
    const nome = String(perfil.perfil_acesso_nome || '').toLowerCase();
    return nome.includes('admin');
  } catch {
    return false;
  }
}

/** Nome amigável de cada categoria de pedido. */
export const NOMES_CATEGORIA = {
  WS: 'Venda',
  WD: 'Doação',
  WC: 'Certificação',
};

/** Nome amigável de uma categoria ('WD' → 'Doação'); devolve o código se desconhecida. */
export function nomeCategoria(tipopedidoid) {
  const key = String(tipopedidoid || '').toUpperCase();
  return NOMES_CATEGORIA[key] || tipopedidoid || '';
}

/** Pedido é da categoria doação (WD)? Pedidos de doação não têm valor mínimo. */
export function isPedidoDoacao(tipopedidoid) {
  return String(tipopedidoid || '').toUpperCase() === 'WD';
}

/**
 * Preferência CLIENTE_OCULTAR_INFO_COMERCIAL: quando ativa, o perfil Cliente
 * não vê informações de representante, condição de pagamento e tabela de
 * preço (Info. Pedido, carrinho e Operações). Ocultação APENAS visual — a
 * lógica e as requisições por trás continuam iguais.
 */
export function ocultarInfoComercialCliente(store) {
  try {
    return isPerfilClienteAtivo() && store.getters['preferencias/clienteOcultarInfoComercial'] === true;
  } catch {
    return false;
  }
}

/**
 * Preferência REPRESENTANTE_OCULTAR_INFO_COMERCIAL: quando ativa, o perfil
 * Representante não vê APENAS tabela de preço e condição de pagamento
 * (os campos de representante continuam visíveis). Ocultação apenas visual.
 */
export function ocultarTabelaCondicaoRepresentante(store) {
  try {
    return isPerfilRepresentanteAtivo() && store.getters['preferencias/representanteOcultarInfoComercial'] === true;
  } catch {
    return false;
  }
}

/**
 * Preferência SUPERVISOR_OCULTAR_INFO_COMERCIAL: mesmo comportamento do gate
 * do Representante (tabela de preço e condição de pagamento), aplicado ao
 * perfil Supervisor. Ocultação apenas visual.
 */
export function ocultarTabelaCondicaoSupervisor(store) {
  try {
    return isPerfilSupervisorAtivo() && store.getters['preferencias/supervisorOcultarInfoComercial'] === true;
  } catch {
    return false;
  }
}
